module.exports = __webpack_public_path__ + "media/newstyle/images/icon-have-2c6130774270ce3340995f03a4d84ec7.svg";